import React, { FC, type ReactNode } from 'react'

export function Tooltip({ message, children, position = 'bottom', className = '', popupClassName = '', onClick }: { message: string, children: ReactNode, position?: 'top' | 'bottom', className?: string, popupClassName?: string, onClick?: () => void }) {
  return (
    <div className={`group/tooltip relative flex ${className}`} onClick={onClick}>
      {children}
      {position === 'bottom' ? (
        <span className={`absolute top-full mt-2 left-1/2 -translate-x-1/2 whitespace-nowrap transition-all rounded-md bg-gray-900 px-2 py-1.5 text-xs text-white opacity-0 scale-95 pointer-events-none group-hover/tooltip:opacity-100 group-hover/tooltip:scale-100 z-[99999] shadow-lg ${popupClassName}`}>
          {message}
        </span>
      ) : (
        <span className={`absolute bottom-full mb-2 left-1/2 -translate-x-1/2 whitespace-nowrap transition-all rounded-md bg-gray-900 px-2 py-1.5 text-xs text-white opacity-0 scale-95 pointer-events-none group-hover/tooltip:opacity-100 group-hover/tooltip:scale-100 z-[99999] shadow-lg ${popupClassName}`}>
          {message}
        </span>
      )}
    </div>
  )
}